import React, { Component } from "react";
import GLOBALS from '../utils/Constants';
import CryptoJS from 'crypto-js'
import moment from 'moment-timezone';
import UserService from './users-service';


export default class FormsService {

    static sharedInstance = FormsService.sharedInstance == null ? new FormsService() : this.sharedInstance;

    constructor() {
       // UserService.sharedInstance.checkIfTokenIsValid();
    }


    async uploadFormsToS3(params){

        const data = new FormData();

        data.append("file", params.file);
        data.append("auth_username", params.auth_username);
        data.append("token", params.token);
        data.append("sub_user_id", params.sub_user_id);
        data.append("license", params.license)
        data.append("client", params.client)
        data.append("branch_name", params.branch_name);
        data.append("branch_id", params.branch_id)
        data.append("facility_id", params.facility_id);
        data.append("facility_name", params.facility_name)
        data.append("client_id", params.client_id);
        data.append("client_name", params.client_name)

        const response = await fetch(GLOBALS.API_UPLOAD_FORM_TO_S3, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            alert("Error in uploading the file.");
        }
    }

    async getAllFormsByLicense(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_GET_ALL_FORMS_BY_LICENSE+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("error");
            console.error(error);
        }
    }

    async saveCustomForm(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_SAVE_CUSTOM_FORM, {
            method: 'POST',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("error", error);
        }
    }

    //call to submit custom form -> Archives?
    async submitCustomForm(params){
        let data = new FormData();

        for (var i = 0; i <  params.files.length; i++) {
            data.append('files[]', params.files[i]);
        }

        data.append("license", params.license);
        data.append("auth_username", params.auth_username);
        data.append("token", params.token);
        data.append("sub_user_id", params.sub_user_id);
        data.append("form_id", params.form_id);
        data.append("json_string", params.json_string);
        data.append("update_attachments_flag", params.update_attachments_flag);

        const response = await fetch(GLOBALS.API_SUBMIT_CUSTOM_FORM, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();

        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("error", error);
            alert("Saving custom form failed.");
        }
    }

    //call to updated the submitted custom form
    async updateSubmittedCustomForm(params){
        let data = new FormData();

        for (var i = 0; i <  params.files.length; i++) {
            data.append('files[]', params.files[i]);
        }

        data.append("license", params.license);
        data.append("auth_username", params.auth_username);
        data.append("token", params.token);
        data.append("sub_user_id", params.sub_user_id);
        data.append("form_id", params.form_id);
        data.append("json_string", params.json_string);
        data.append("update_attachments_flag", params.update_attachments_flag);
        data.append("id", params.id);

        const response = await fetch(GLOBALS.API_UPDATE_SUBMITTED_FORM, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("error", error);
            alert("Saving custom form failed.");
        }
    }

    //get all forms submitted by user (passing the sub_user_id)
    async getSubmittedCustomForms(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);
        const response = await fetch(GLOBALS.API_GET_SUBMITTED_FORMS+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            }
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("error", error);
            alert("Saving custom form failed.");
        }
    }

     //get submitted form by passing the Submitted Form ID
     async getSubmittedCustomFormById(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);
        const response = await fetch(GLOBALS.API_GET_SUBMITTED_FORM_BY_ID+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("error", error);
            alert("Saving custom form failed.");
        }
    }

    /** Forms->Archive->Delete **/
    async deleteSubmittedForm(params){
        /* params will look like this
        let params = {
             "license": "",
             "token": "",
             "auth_username": "",
             "id": "" //id of the submitted form
        };*/

        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_DELETE_SUBMITTED_FORM, {
            method: 'DELETE',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;

        } catch (error) {
            console.error(error);
        }
    }

    /** Settings->Forms->Delete **/
    async delete(params){
        /* params will look like this
        let params = {
             "license": "",
             "token": "",
             "auth_username": "",
             "id": "" //id of the form (form.recno)
        };*/
        const formBody = UserService.sharedInstance.urlEncodeParams(params);


        const response = await fetch(GLOBALS.API_DELETE_FORM, {
            method: 'DELETE',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });

        const responseJson = await response.json();

        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;

        } catch (error) {
            console.error(error);
            return error
        }
    }

    //get submitted form by passing the Submitted Form ID
     async getSubmittedCustomFormByLicense(params){
        const formBody = UserService.sharedInstance.urlEncodeParams(params);
        const response = await fetch(GLOBALS.API_GET_SUBMITTED_FORM_BY_LICENSE+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            }
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("error", error);
        }
    }
    /*** End of API Calls ***/
}
